<div class="overview-form-container">
  <form #OverviewForm="ngForm">
    <div class="field-row">
      <rms-input name="CompanyName" [required]="true" label="DBA" [(ngModel)]="Customer.CompanyName"></rms-input>
      <div class="credit-limit-field">
        <rms-input name="CreditLimit" label="Credit Limit" type="currency" [disabled]="isCashTerm" [(ngModel)]="Customer.CreditLimit"></rms-input>
        @if(isCashTerm){<div class="cash-term-note">Not applicable for cash terms</div>}
      </div>
    </div>
    <div class="field-row">
      <rms-input name="OciaMemberNumber" label="OCIA Member Number" [(ngModel)]="Customer.OciaMemberNumber"></rms-input>
      <rms-checkbox name="NonDomestic" label="Non-Domestic" [(ngModel)]="Customer.NonDomestic"></rms-checkbox>
    </div>
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!OverviewForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
